window.THEME_PRODUCT_CARD_CACHE = window.THEME_PRODUCT_CARD_CACHE || new Map()
window.THEME_SWATCH_CACHE = window.THEME_SWATCH_CACHE || new Map()

class CardProductGroupSwatches extends HTMLElement {
  constructor() {
    super()
    this.abortController = new AbortController()
    this.group = this.dataset.group
    this.productHandle = this.dataset.productHandle
    this.items = null
    this.productCardParent = this.closest('[data-product-card]').parentElement
    this.cardWrapper = this.productCardParent.querySelector('.card-wrapper')
    this.showSlider = this.cardWrapper.dataset.showSlider
    this.isSectionRendered = this.dataset.isSectionRendered
    this.fetchItems()
  }

  connectedCallback() {
    if (this.isSectionRendered === 'true') {
      const nestedCard = this.cardWrapper.querySelector('.card')

      // We don't want hover effect on image to happen as soon as swatch is clicked and new card is loaded. User should have to mouse out first.
      if (nestedCard) {
        nestedCard.addEventListener(
          'mouseleave',
          (event) => {
            if (
              event.relatedTarget?.matches('button.product-form__color-swatch')
            ) {
              return
            }
            nestedCard?.classList.remove('section-rendered-no-hover')
          },
          { signal: this.abortController.signal }
        )
      }
    }
  }

  async handleSwatchClick(url) {
    const liquidSection =
      this.showSlider === 'true'
        ? 'product-card-with-slider'
        : 'product-card-without-slider'

    const sectionRenderedHtml =
      window.THEME_PRODUCT_CARD_CACHE.get(url) ||
      (await fetch(`${url}/?section_id=${liquidSection}`)
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html')
          window.THEME_PRODUCT_CARD_CACHE.set(url, html)
          return html
        })
        .catch((error) => {
          window.location.href = url
          console.error('Error fetching product card:', error)
        }))

    const card = sectionRenderedHtml?.querySelector('[data-product-card]')

    if (!sectionRenderedHtml || !card) {
      throw new Error('Product card HTML not found')
    }

    sectionRenderedHtml
      .querySelector('card-product-group-swatches')
      ?.setAttribute('data-is-section-rendered', true)

    card.querySelector('.card')?.classList.add('section-rendered-no-hover')

    if (this.cardWrapper.classList.contains('card-wrapper--padding-mobile')) {
      sectionRenderedHtml
        .querySelector('.card-wrapper')
        .classList.add('card-wrapper--padding-mobile')
    }

    if (this.cardWrapper.classList.contains('card-wrapper--padding-desktop')) {
      sectionRenderedHtml
        .querySelector('.card-wrapper')
        .classList.add('card-wrapper--padding-desktop')
    }

    const uid = Math.floor(Math.random() * 999999)
    const form = sectionRenderedHtml.querySelector('product-form form')
    const radios = sectionRenderedHtml.querySelectorAll('variant-radios input')
    const wishlistButton = sectionRenderedHtml.querySelector(
      'swym-wishlist-button'
    )

    card.dataset.id = `section-rendered-slider-${uid}`

    if (form) {
      form.id = `section-rendered-form-${uid}`
    }
    if (radios) {
      radios.forEach((radio) =>
        radio.setAttribute('form', `section-rendered-form-${uid}`)
      )
    }
    if (wishlistButton) {
      wishlistButton.dataset.swymBtnContainer = `section-rendered-swym-${uid}`
    }

    const productCardParentHtml = sectionRenderedHtml.querySelector(
      '[data-product-card]'
    ).parentElement.innerHTML
    this.productCardParent.innerHTML = productCardParentHtml
  }

  initButtons() {
    this.buttons = this.querySelectorAll('button')
    this.buttons.forEach((button) => {
      button.addEventListener(
        'click',
        () => {
          // Prevent hover state from being applied to the button after clicking on mobile
          if (window.matchMedia('(max-width: 989px)').matches) {
            const nestedCard = this.cardWrapper.querySelector('.card')
            nestedCard.classList.add('section-rendered-no-hover');
          }
          this.handleSwatchClick(button.dataset.url)
        },
        { signal: this.abortController.signal }
      )
    })
  }

  async fetchItems() {
    this.items =
      window.THEME_SWATCH_CACHE.get(`${this.group}`) ||
      (await fetch(`/collections/all/${this.group}?view=ajax`).then((res) =>
        res.json()
      ))
    if (!this.items || this.items.length == 1) return
    window.THEME_SWATCH_CACHE.set(`${this.group}`, this.items)

    this.items.sort((x, y) => {
      return x.handle === this.productHandle
        ? -1
        : y.handle === this.productHandle
          ? 1
          : 0
    })

    let optionsHtml = this.items
      .slice(0, 5)
      .map((item, index) => {
        return `<button type="button"
        data-url="${item.url}"
        style="--swatch-background-image: url('${item.swatch_url}');"
        class="product-form__color-swatch${index == 4 ? ' product-form__color-swatch--desktop' : ''}${this.productHandle === item.handle ? ' active' : ''}"
      ><span class="visually-hidden">${item.swatch_value}</span></button>`
      })
      .join('')

    if (this.items.length > 5) {
      optionsHtml += `<span class="product-form__color-total product-form__color-total--desktop">+ ${this.items.length - 5} more</span>`
      optionsHtml += `<span class="product-form__color-total product-form__color-total--mobile">+ ${this.items.length - 4} more</span>`
    }

    this.innerHTML = optionsHtml
    this.initButtons()
  }

  disconnectedCallback() {
    this.abortController.abort()
  }
}

customElements.define('card-product-group-swatches', CardProductGroupSwatches)
